import { render, staticRenderFns } from "./leaveWord.vue?vue&type=template&id=696ff138&scoped=true"
import script from "./leaveWord.vue?vue&type=script&lang=js"
export * from "./leaveWord.vue?vue&type=script&lang=js"
import style0 from "./leaveWord.vue?vue&type=style&index=0&id=696ff138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ff138",
  null
  
)

export default component.exports